<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p style="text-align: center;"><span dir="rtl">إلى كلِّ الظِّلال الدافئة التي وقفَت خلفي لتدفعني إلى الأمام..</span></p>
<p style="text-align: center;"><span dir="rtl">شكرًا.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?72556142